import React, { useState } from 'react';
import './Dashboard.css';
import Sidebar from './Sidebar'; // Import the new component
import StatCard from './StatCard'; // Optional: separate this too if you like

const Dashboard = () => {
  const [isToggled, setIsToggled] = useState(false);

  return (
    <div className={`d-flex ${isToggled ? 'toggled' : ''}`} id="wrapper">
      
      {/* SEPARATE SIDEBAR COMPONENT */}
      <Sidebar />

      {/* Page Content */}
      <div id="page-content-wrapper" className="bg-light flex-grow-1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom px-4">
          <div className="d-flex align-items-center w-100">
            <i 
              className="bi bi-list fs-4 me-3 cursor-pointer" 
              onClick={() => setIsToggled(!isToggled)}
            ></i>
            
            <div className="input-group search-box d-none d-md-flex">
              <span className="input-group-text bg-transparent border-0"><i className="bi bi-search"></i></span>
              <input type="text" className="form-control border-0" placeholder="Search... (Ctrl + K)" />
            </div>

            <div className="ms-auto d-flex align-items-center gap-3">
               <i className="bi bi-bell position-relative"><span className="badge rounded-pill bg-success">2</span></i>
               {/* <img src="https://i.pravatar.cc/35" className="rounded-circle" alt="profile" /> */}
            </div>
          </div>
        </nav>

        <div className="container-fluid p-4">
          {/* Welcome Banner */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm text-white overflow-hidden" 
                   style={{ background: 'linear-gradient(135deg, #3366ff 0%, #6699ff 100%)', borderRadius: '15px' }}>
                <div className="card-body p-5">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <h2 className="fw-bold">Explore Redesigned VPS Dashboard</h2>
                      <p className="opacity-75">Professional infrastructure management powered by Material-UI design principles.</p>
                      <button className="btn btn-outline-light px-4 mt-2">Download Report</button>
                    </div>
                    <div className="col-md-5 text-center d-none d-md-block">
                       <span style={{ fontSize: '80px' }}>🚀</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="row g-4">
            <StatCard icon="bi-wallet2" label="All Earnings" val="$3000" color="primary" />
            <StatCard icon="bi-file-earmark" label="Page Views" val="290+" color="warning" />
            <StatCard icon="bi-calendar-check" label="Total Task" val="1,568" color="success" />
            <StatCard icon="bi-download" label="Download" val="$200" color="danger" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;